import React, {useState, useEffect, useRef} from 'react';
import {Tooltip} from "primereact/tooltip";
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import {Link} from "react-router-dom";
import {Timeline} from 'primereact/timeline';
import {Dialog} from "primereact/dialog";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import _FM_ReservationGuestListComponent from "./_FM_ReservationGuestListComponent";
import _FM_ReservationBillingdataFormComponent from "./_FM_ReservationBillingdataFormComponent";
import _FM_FolioListComponent from "../../components/_FM_folio/_FM_FolioListComponent";
import _FM_ReservationErrorsListComponent from "./_FM_ReservationErrorsListComponent";
import _FM_ReceiptListComponent from "../_FM_receipt/_FM_ReceiptListComponent";
import _FM_ReservationEzeepricesListComponent from "./_FM_ReservationEzeepricesListComponent";
import {Field} from "react-final-form";
import {classNames} from "primereact/utils";
import {InputText} from "primereact/inputtext";
import _FM_ReservationResnwebListComponent from "./_FM_ReservationResnwebListComponent";
import _FM_ReservationgroupShowComponent from "../_FM_reservationgroup/_FM_ReservationgroupShowComponent";
import _FM_GroupShowComponent from "../_FM_group/_FM_GroupShowComponent";
import ReservationCountrySpecificComponent from "./_FM_ReservationCountrySpecificComponent";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_ReservationShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [attachData, setAttachData] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [reservationGroup, setReservationGroup] = useState(null);
  const [groupDialog, setGroupDialog] = useState(false);
  const [unit, setUnit] = useState([]);
  const [berth, setBerth] = useState([]);
  const [email, setEmail] = useState({
    language: Cookies.get("language").toUpperCase(),
    client_domain: process.env.REACT_APP_APP_PROTOCOL + window.location.hostname.split('.')[0]
      + "." + process.env.REACT_APP_APP_HOST.replace('/#/', '/#')
  });
  const [loading, setLoading] = useState(false);
  const [hotelConnectRetryLoading, setHotelConnectRetryLoading] = useState(false);
  const [hotelConnectCheckinRetryLoading, setHotelConnectCheckinRetryLoading] = useState(false);
  const [hotelConnectCheckoutRetryLoading, setHotelConnectCheckoutRetryLoading] = useState(false);
  const [hotelConnectRoomChangeRetryLoading, setHotelConnectRoomChangeRetryLoading] = useState(false);
  const [tabActiveIndex, setTabActiveIndex] = useState(0);
  const [countrySpecificEnabled, setCountrySpecificEnabled] = useState(null);
  const isRelocatedReservation = Boolean(formData?.relocated_to);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const getReservationNavigationPath = (reservationId) => {
    const currentAction = action || 'read';
    const hash = window.location.hash.toString();

    if (hash.includes('#/calendar')) {
      return '/calendar/' + currentAction + '/' + reservationId;
    }
    if (hash.includes('#/control-panel')) {
      return '/control-panel/reservation/' + currentAction + '/' + reservationId;
    }
    if (hash.includes('#/folio')) {
      return '/folio/' + currentAction + '/' + reservationId;
    }
    return '/reservation/' + currentAction + '/' + reservationId;
  }

  const getCloseNavigationPath = () => {
    const hash = window.location.hash.toString();
    return hash.includes('#/calendar') ? '/calendar' : '/reservation';
  }

  const getHotelConnectStatusMeta = (status) => {
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase().trim() : '';
    const neutralStyle = {backgroundColor: '#dddddd', color: '#5f656b'};
    if (normalizedStatus === 'success') {
      return {badgeClass: '', label: t('hotelconnect_status_success'), style: {backgroundColor: '#0abb87', color: '#ffffff'}};
    }
    if (normalizedStatus === 'failed') {
      return {badgeClass: '', label: t('hotelconnect_status_failed'), style: {backgroundColor: '#f7a2a2', color: '#5f656b'}};
    }
    if (normalizedStatus === 'skipped') {
      return {badgeClass: '', label: t('hotelconnect_status_skipped'), style: neutralStyle};
    }
    return {badgeClass: '', label: t('hotelconnect_status_not_started'), style: neutralStyle};
  };

  const setHotelConnectSyncStateFromPayload = (payload) => {
    if (!payload) {
      return;
    }

    const getValue = (camelKey, snakeKey, previousValue = null) => {
      if (payload?.[camelKey] !== undefined && payload?.[camelKey] !== null) {
        return payload[camelKey];
      }
      if (payload?.[snakeKey] !== undefined && payload?.[snakeKey] !== null) {
        return payload[snakeKey];
      }
      return previousValue;
    };

    setFormData((prevState) => ({
      ...prevState,
      hotelConnectFoglalasStatus: getValue('hotelConnectFoglalasStatus', 'hotel_connect_foglalas_status', prevState?.hotelConnectFoglalasStatus ?? prevState?.hotel_connect_foglalas_status ?? null),
      hotelConnectFoglalasError: getValue('hotelConnectFoglalasError', 'hotel_connect_foglalas_error', prevState?.hotelConnectFoglalasError ?? prevState?.hotel_connect_foglalas_error ?? null),
      hotelConnectFoglalasSyncedAt: getValue('hotelConnectFoglalasSyncedAt', 'hotel_connect_foglalas_synced_at', prevState?.hotelConnectFoglalasSyncedAt ?? prevState?.hotel_connect_foglalas_synced_at ?? null),
      hotelConnectCheckinStatus: getValue('hotelConnectCheckinStatus', 'hotel_connect_checkin_status', prevState?.hotelConnectCheckinStatus ?? prevState?.hotel_connect_checkin_status ?? null),
      hotelConnectCheckinError: getValue('hotelConnectCheckinError', 'hotel_connect_checkin_error', prevState?.hotelConnectCheckinError ?? prevState?.hotel_connect_checkin_error ?? null),
      hotelConnectCheckinSyncedAt: getValue('hotelConnectCheckinSyncedAt', 'hotel_connect_checkin_synced_at', prevState?.hotelConnectCheckinSyncedAt ?? prevState?.hotel_connect_checkin_synced_at ?? null),
      hotelConnectCheckoutStatus: getValue('hotelConnectCheckoutStatus', 'hotel_connect_checkout_status', prevState?.hotelConnectCheckoutStatus ?? prevState?.hotel_connect_checkout_status ?? null),
      hotelConnectCheckoutError: getValue('hotelConnectCheckoutError', 'hotel_connect_checkout_error', prevState?.hotelConnectCheckoutError ?? prevState?.hotel_connect_checkout_error ?? null),
      hotelConnectCheckoutSyncedAt: getValue('hotelConnectCheckoutSyncedAt', 'hotel_connect_checkout_synced_at', prevState?.hotelConnectCheckoutSyncedAt ?? prevState?.hotel_connect_checkout_synced_at ?? null),
      hotelConnectRoomChangeStatus: getValue('hotelConnectRoomChangeStatus', 'hotel_connect_room_change_status', prevState?.hotelConnectRoomChangeStatus ?? prevState?.hotel_connect_room_change_status ?? null),
      hotelConnectRoomChangeError: getValue('hotelConnectRoomChangeError', 'hotel_connect_room_change_error', prevState?.hotelConnectRoomChangeError ?? prevState?.hotel_connect_room_change_error ?? null),
      hotelConnectRoomChangeSyncedAt: getValue('hotelConnectRoomChangeSyncedAt', 'hotel_connect_room_change_synced_at', prevState?.hotelConnectRoomChangeSyncedAt ?? prevState?.hotel_connect_room_change_synced_at ?? null),
    }));
  };

  const refreshReservationSyncData = () => {
    if (!id) {
      return;
    }
    apiCall('get', 'reservation/' + id)
      .then((response) => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
      })
      .catch(() => {
      });
  };

  const retryHotelConnectFoglalasSync = () => {
    if (!id) {
      return;
    }
    setHotelConnectRetryLoading(true);
    apiCall('post', 'reservation/' + id + '/hotelconnect-ntak-foglalas-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectRetryLoading(false);
      })
  };

  const retryHotelConnectCheckinSync = () => {
    if (!id) {
      return;
    }
    setHotelConnectCheckinRetryLoading(true);
    apiCall('post', 'reservation/' + id + '/hotelconnect-ntak-checkin-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectCheckinRetryLoading(false);
      })
  };

  const retryHotelConnectCheckoutSync = () => {
    if (!id) {
      return;
    }
    setHotelConnectCheckoutRetryLoading(true);
    apiCall('post', 'reservation/' + id + '/hotelconnect-ntak-checkout-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectCheckoutRetryLoading(false);
      })
  };

  const retryHotelConnectRoomChangeSync = () => {
    if (!id) {
      return;
    }
    setHotelConnectRoomChangeRetryLoading(true);
    apiCall('post', 'reservation/' + id + '/hotelconnect-ntak-room-change-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectRoomChangeRetryLoading(false);
      })
  };

  useEffect(() => {
    if (attachData.residential_unit) {
      apiCall('get', 'berth' + '?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + attachData.residential_unit)
        .then(response => {
          setLoading(false)
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }

  }, [attachData.residential_unit])

  useEffect(() => {
    setLoading(true)
    if (id) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          const reservationData = response.data.data;
          setFormData(reservationData);
          if (reservationData?.reservation_group?.group?.name) {
            setReservationGroup(reservationData.reservation_group);
          }
          let _statuses = [
            {
              status: 'pending',
              label: t('pending'),
              date: null,
              step: 0,
            },
            {
              status: 'confirmed',
              label: t('reserved'),
              date: null,
              step: 1,
            },
            {
              status: 'checked_in',
              label: t('checked_in'),
              date: response.data.data.checked_in,
              step: 2,
            },
            {
              status: 'checked_out',
              label: t('checked_out'),
              date: reservationData.checked_out,
              step: 3,
            },
            {
              status: 'cancelled',
              label: t('cancelled'),
              date: null,
              step: 4,
            },
          ]
          _statuses.map((status, index) => {
            const statusForHistory = status.status === 'checked_out' && reservationData.status === 'relocated'
              ? 'relocated'
              : status.status;
            apiCall('get', 'reservation-status-change?search[reservation][operator]=%3D&search[reservation][value]=' + id
              + '&search[new_status][operator]=%3D&search[new_status][value]=' + statusForHistory)
              .then(response => {
                if (response.data.data.items && response.data.data.items[0]) {
                  _statuses[index] = {
                    status: status.status,
                    label: status.label,
                    date: response.data.data.items[0].created_at_snapshot,
                    step: status.step
                  }
                }
              })
              .catch(error => {

              })
          })
          setStatuses(_statuses)
          if (reservationData?.reservation_group?.id) {
            axios({
              method: 'get',
              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation-group/" + reservationData.reservation_group.id,
              params: {},
              headers: {
                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                "Sys-name": Cookies.get("instanceId"),
                "Preferred-locale": Cookies.get("language")
              }
            })
              .then(response => {
                setReservations(response.data.data.reservations);
                setReservationGroup(response?.data?.data || null);
              })
              .catch(error => {

              })
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    apiCall('get', 'residential-unit')
      .then(response => {
        setLoading(false)
        setUnit(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (window.App.urlVars().read === 'folio'
      || window.App.urlVars().update === 'folio'
      || window.App.urlVars().create === 'folio'
      || window.App.urlVars().manage === 'folio') {
      setTabActiveIndex(2)
    }
  }, [id, action, window.App.state.rerenderReservationList])

  useEffect(() => {
    if (!id) {
      return undefined;
    }

    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/api/reservation/" + id;
    const eventSource = openMercureSubscription({
      topics: [topic],
      onMessage: (event) => {
        try {
          const data = JSON.parse(event?.data || '{}');
          const eventName = data?.event;
          const updateEvents = [
            'hotelconnect_ntak_foglalas_sync_updated',
            'hotelconnect_ntak_checkin_sync_updated',
            'hotelconnect_ntak_checkout_sync_updated',
            'hotelconnect_ntak_room_change_sync_updated',
          ];
          const refreshEvents = [
            'hotelconnect_ntak_checkin_sync_succeeded',
            'hotelconnect_ntak_checkin_sync_failed',
            'hotelconnect_ntak_checkout_sync_succeeded',
            'hotelconnect_ntak_checkout_sync_failed',
            'hotelconnect_ntak_room_change_sync_succeeded',
            'hotelconnect_ntak_room_change_sync_failed',
          ];

          if (!updateEvents.includes(eventName) && !refreshEvents.includes(eventName)) {
            return;
          }
          if (updateEvents.includes(eventName)) {
            setHotelConnectSyncStateFromPayload(data);
          } else {
            refreshReservationSyncData();
          }
        } catch (error) {
        }
      }
    });

    if (!eventSource) {
      return undefined;
    }

    return () => {
      closeMercureSubscription(eventSource);
    };
  }, [id]);

  const hotelConnectFoglalasStatus = formData?.hotelConnectFoglalasStatus ?? formData?.hotel_connect_foglalas_status ?? null;
  const normalizedHotelConnectFoglalasStatus = typeof hotelConnectFoglalasStatus === 'string'
    ? hotelConnectFoglalasStatus.toLowerCase().trim()
    : '';
  const hotelConnectFoglalasStatusMeta = getHotelConnectStatusMeta(hotelConnectFoglalasStatus);
  const isHotelConnectFoglalasSyncFailed = normalizedHotelConnectFoglalasStatus === 'failed';
  const hotelConnectFoglalasError = formData?.hotelConnectFoglalasError ?? formData?.hotel_connect_foglalas_error ?? null;

  const hotelConnectCheckinStatus = formData?.hotelConnectCheckinStatus ?? formData?.hotel_connect_checkin_status ?? null;
  const normalizedHotelConnectCheckinStatus = typeof hotelConnectCheckinStatus === 'string'
    ? hotelConnectCheckinStatus.toLowerCase().trim()
    : '';
  const hotelConnectCheckinStatusMeta = getHotelConnectStatusMeta(hotelConnectCheckinStatus);
  const isHotelConnectCheckinSyncFailed = normalizedHotelConnectCheckinStatus === 'failed';
  const hotelConnectCheckinError = formData?.hotelConnectCheckinError ?? formData?.hotel_connect_checkin_error ?? null;

  const hotelConnectCheckoutStatus = formData?.hotelConnectCheckoutStatus ?? formData?.hotel_connect_checkout_status ?? null;
  const normalizedHotelConnectCheckoutStatus = typeof hotelConnectCheckoutStatus === 'string'
    ? hotelConnectCheckoutStatus.toLowerCase().trim()
    : '';
  const hotelConnectCheckoutStatusMeta = getHotelConnectStatusMeta(hotelConnectCheckoutStatus);
  const isHotelConnectCheckoutSyncFailed = normalizedHotelConnectCheckoutStatus === 'failed';
  const hotelConnectCheckoutError = formData?.hotelConnectCheckoutError ?? formData?.hotel_connect_checkout_error ?? null;
  const hotelConnectRoomChangeStatus = formData?.hotelConnectRoomChangeStatus ?? formData?.hotel_connect_room_change_status ?? null;
  const normalizedHotelConnectRoomChangeStatus = typeof hotelConnectRoomChangeStatus === 'string'
    ? hotelConnectRoomChangeStatus.toLowerCase().trim()
    : '';
  const hotelConnectRoomChangeStatusMeta = getHotelConnectStatusMeta(hotelConnectRoomChangeStatus);
  const isHotelConnectRoomChangeSyncFailed = normalizedHotelConnectRoomChangeStatus === 'failed';
  const hotelConnectRoomChangeError = formData?.hotelConnectRoomChangeError ?? formData?.hotel_connect_room_change_error ?? null;
  const showHotelConnectRoomChangeSync = Boolean(formData?.relocated_from);
  const reservationShowSyncIdentifier = formData?.id || id || 'new';

  const renderHotelConnectSyncRow = (rowKey, label, statusMeta, isFailed, errorText, retryLoading, retryAction) => (
    <li className="p-mb-3" key={rowKey}>
      <div className="p-d-flex p-ai-center p-jc-between p-flex-wrap" style={{gap: '0.5rem'}}>
        <div className="p-d-flex p-ai-center" style={{gap: '0.4rem'}}>
          {errorText &&
            <>
              <span
                className={`tt-hotelconnect-error-${rowKey}-show-${reservationShowSyncIdentifier}`}
                data-pr-tooltip={errorText}
                style={{display: 'inline-flex', color: '#f44336'}}
              >
                <i className="pi pi-info-circle" style={{fontSize: '0.8rem'}}></i>
              </span>
              <Tooltip target={`.tt-hotelconnect-error-${rowKey}-show-${reservationShowSyncIdentifier}`}/>
            </>
          }
          <span>{label}</span>
        </div>
        <span
          className={classNames(
            'p-badge p-text-bold',
            statusMeta.badgeClass,
            `tt-hotelconnect-retry-${rowKey}-show-${reservationShowSyncIdentifier}`
          )}
          data-pr-tooltip={isFailed ? t('hotelconnect_sync_retry_label') : undefined}
          role={isFailed ? 'button' : undefined}
          tabIndex={isFailed ? (retryLoading ? -1 : 0) : undefined}
          style={{
            ...statusMeta.style,
            width: '110px',
            minWidth: '110px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.35rem',
            cursor: isFailed && !retryLoading ? 'pointer' : 'default'
          }}
          onClick={() => {
            if (!isFailed || retryLoading) {
              return;
            }
            retryAction();
          }}
          onKeyDown={(event) => {
            if (!isFailed || retryLoading) {
              return;
            }
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              retryAction();
            }
          }}
        >
          <span>{statusMeta.label}</span>
          {isFailed &&
            <>
              <i
                className={`pi ${retryLoading ? 'pi-spin pi-spinner' : 'pi-refresh'}`}
                style={{color: 'inherit', fontSize: '0.8rem'}}
              ></i>
              <Tooltip target={`.tt-hotelconnect-retry-${rowKey}-show-${reservationShowSyncIdentifier}`}/>
            </>
          }
        </span>
      </div>
    </li>
  );

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
            {t('reservation_show')}
            {formData.relocated_to &&
              <>
                <span
                  className={"tt-relocated-to-reservation-show-info-" + formData.id + " p-ml-2 p-mr-2"}
                  data-pr-tooltip={t('reservation_number') + ': ' + (formData?.relocated_to?.public_id || '-') + ' (#' + (formData?.relocated_to?.id || '-') + ')'}>
                  <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-relocated-to-reservation-show-info-" + formData.id} autoHide={false}>
                  <span>
                    {t('reservation_number')}:{' '}
                    <span
                      style={{cursor: 'pointer', textDecoration: 'underline'}}
                      onClick={() => navigate(getReservationNavigationPath(formData.relocated_to.id))}>
                      {formData.relocated_to.public_id} (#{formData.relocated_to.id})
                    </span>
                  </span>
                </Tooltip>
                <span
                  className={"p-badge p-badge-warning p-text-nowrap"}>
                  {t('relocated_to')}
                  <i className="pi pi-sign-in p-ml-1" style={{fontSize: "0.6rem"}}></i>
                </span>
              </>
            }
            {formData.relocated_from &&
              <>
                <span
                  className={"tt-relocated-from-reservation-show-info-" + formData.id + " p-mr-2 p-ml-2"}
                  data-pr-tooltip={t('reservation_number') + ': ' + (formData?.relocated_from?.public_id || '-') + ' (#' + (formData?.relocated_from?.id || '-') + ')'}>
                  <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-relocated-from-reservation-show-info-" + formData.id} autoHide={false}>
                  <span>
                    {t('reservation_number')}:{' '}
                    <span
                      style={{cursor: 'pointer', textDecoration: 'underline'}}
                      onClick={() => navigate(getReservationNavigationPath(formData.relocated_from.id))}>
                      {formData.relocated_from.public_id} (#{formData.relocated_from.id})
                    </span>
                  </span>
                </Tooltip>
                <span
                  className={"p-badge p-badge-warning p-text-nowrap"}>
                  <i className="pi pi-sign-out p-mr-1" style={{fontSize: "0.6rem"}}></i>
                  {t('relocated_from')}
                </span>
              </>
            }
            <span style={{float: 'right', fontSize: '1rem'}} className={"p-text-normal p-mt-1"}>
              {formData.errors && formData.errors[0] &&
                <span style={{cursor: "help"}} className={"p-text-normal p-ml-2"} onClick={() => {
                  const targetElement = document.getElementById('errors');
                  if (targetElement) {
                    targetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
                  }
                }}>
                  <i className={"pi pi-exclamation-triangle p-mr-2"}
                     style={{position: "relative", top: '1px'}}></i>{t('error_found_in_reservation')}
                </span>
              }
            </span>
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"} style={{maxWidth: '100px'}}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  disabled={isRelocatedReservation}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/')
                      setTimeout(() => {
                        navigate('/calendar/update/' + id)
                      }, 500)
                    }
                    if (window.location.hash.toString().includes('#/control-panel')) {
                      navigate('/control-panel/')
                      setTimeout(() => {
                        navigate('/control-panel/reservation/update/' + id)
                      }, 500)
                    }
                    if (window.location.hash.toString().includes('#/folio')) {
                      navigate('/folio/')
                      setTimeout(() => {
                        navigate('/folio/update/' + id)
                      }, 500)
                    }
                    if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/')
                      setTimeout(() => {
                        navigate('/reservation/update/' + id)
                      }, 500)
                    }
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(getCloseNavigationPath())
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('accommodation')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            <span className={"p-text-nowrap"}>
              {formData?.accommodation?.name}
              <span className={"tt-auto-invoice p-ml-2"}
                    data-pr-tooltip={formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                className={"auto-invoice-icon"} style={{
                color: formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd',
                position: 'relative',
                bottom: '-3px'
              }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8"/><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1"/><path
                d="M9 7h6"/><path d="M9 11h4"/><path d="M18 14a3 3 0 1 0 3 3"/><path d="M21 20v-3h-3"/></svg></span>
              <Tooltip target=".tt-auto-invoice"/>
            </span>
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('reservation_number')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData.association_code &&
              <>
                <span className={"tt-association-code-reservation-show-info-" + formData.id + " p-mr-2"}
                      data-pr-tooltip={formData.association_code}>
                  <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-association-code-reservation-show-info-" + formData.id}/>
                <span className={"p-badge"}
                      style={{
                        fontSize: '1rem',
                        backgroundColor: formData?.status
                          ? formData?.status?.toLowerCase() === 'pending'
                            ? '#dddddd'
                            : formData?.status?.toLowerCase() === 'confirmed'
                              ? '#f1eea5'
                              : formData?.status?.toLowerCase() === 'cancelled'
                                ? '#f7a2a2'
                                : formData?.status?.toLowerCase() === 'checked_in'
                                  ? '#3ec0e9'
                                  : formData?.status?.toLowerCase() === 'checked_out'
                                    ? '#0abb87'
                                    : formData?.status?.toLowerCase() === 'no_show'
                                      ? '#8a2be2'
                                      : '#ccc'
                          : undefined,
                        color: formData?.status
                          ? formData?.status?.toLowerCase() === 'pending' || formData?.status?.toLowerCase() === 'confirmed'
                            ? '#5f656b'
                            : formData?.status?.toLowerCase() === 'cancelled'
                              ? '#5f656b'
                            : formData?.status?.toLowerCase() === 'no_show'
                              ? '#fff'
                              : undefined
                          : undefined
                }}>
                  {formData?.association_code?.split(' | ').pop()?.trim()}
                </span>
              </>
            }
          </p>
        </div>
        {formData.auto_check_in_at &&
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('auto_check_in_time')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              <span className={"tt-auto-check-in-reservation-show-" + formData.id}
                    data-pr-tooltip={t('auto_check_in_tooltip')}>
                <i className={"pi pi-info-circle p-mr-2"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
              </span>
              <Tooltip target={".tt-auto-check-in-reservation-show-" + formData.id}/>
<span className={"p-badge"}
      style={{
        fontSize: '1rem',
        backgroundColor: formData?.status
          ? formData?.status?.toLowerCase() === 'pending'
            ? '#dddddd'
            : formData?.status?.toLowerCase() === 'confirmed'
              ? '#f1eea5'
              : formData?.status?.toLowerCase() === 'cancelled'
                ? '#f7a2a2'
                : formData?.status?.toLowerCase() === 'checked_in'
                  ? '#3ec0e9'
                  : formData?.status?.toLowerCase() === 'checked_out'
                    ? '#0abb87'
                    : formData?.status?.toLowerCase() === 'no_show'
                      ? '#8a2be2'
                      : '#ccc'
          : undefined,
        color: formData?.status
          ? formData?.status?.toLowerCase() === 'pending' || formData?.status?.toLowerCase() === 'confirmed'
            ? '#5f656b'
            : formData?.status?.toLowerCase() === 'cancelled'
              ? '#5f656b'
            : formData?.status?.toLowerCase() === 'no_show'
              ? '#fff'
              : undefined
          : undefined
      }}>
                  {moment.utc(formData.auto_check_in_at).local().format(t('YYYY-MM-DD HH:mm'))}
                </span>
            </p>
          </div>
        }
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <div className={"p-grid p-py-0 p-mt-2"}>
        <div className={"p-col p-py-0 p-my-0 reservation-status-timeline"}>
          <Timeline layout="horizontal" align="top"
                    value={statuses}
                    marker={(item, index) => {
                      return (
                        <>
                          {formData.status === 'pending' &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              )}
                            </>
                          }
                          {formData.status === 'confirmed' &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 1 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#f1eea5",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <i className={"pi pi-circle"}
                                   style={{
                                     color: "#90959b",
                                     fontSize: '1.5rem',
                                     position: 'relative',
                                     zIndex: '9',
                                     border: '2px solid #f2f3f8',
                                     borderRadius: '100%'
                                   }}></i>
                              )}
                            </>
                          }
                          {formData.status === 'checked_in' &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 1 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#f1eea5",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 2 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#3ec0e9",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <i className={"pi pi-circle"}
                                   style={{
                                     color: "#90959b",
                                     fontSize: '1.5rem',
                                     position: 'relative',
                                     zIndex: '9',
                                     border: '2px solid #f2f3f8',
                                     borderRadius: '100%'
                                   }}></i>
                              )}
                            </>
                          }
                          {(formData.status === 'checked_out' || formData.status === 'relocated') &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 1 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#f1eea5",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 2 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#3ec0e9",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 3 ? (
                                <>
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: formData.status === 'relocated' ? '#fbc02d' : '#0abb87',
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <i className={"pi pi-circle"}
                                   style={{
                                     color: "#90959b",
                                     fontSize: '1.5rem',
                                     position: 'relative',
                                     zIndex: '9',
                                     border: '2px solid #f2f3f8',
                                     borderRadius: '100%'
                                   }}></i>
                              )}
                            </>
                          }
                          {formData.status === 'no_show' &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 1 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#f1eea5",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 2 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#3ec0e9",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 3 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#0abb87",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <i className={"pi pi-circle-fill"}
                                   style={{
                                     color: "#8a2be2",
                                     fontSize: '1.5rem',
                                     position: 'relative',
                                     zIndex: '9',
                                     border: '2px solid #f2f3f8',
                                     borderRadius: '100%'
                                   }}></i>
                              )}
                            </>
                          }
                          {formData.status === 'cancelled' &&
                            <>
                              {item.step === 0 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#dddddd",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 1 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#f1eea5",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 2 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#3ec0e9",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : item.step === 3 ? (
                                <>
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#0abb87",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       border: '2px solid #f2f3f8',
                                       borderRadius: '100%'
                                     }}></i>
                                </>
                              ) : (
                                <i className={"pi pi-circle-fill"}
                                   style={{
                                     color: "#f7a2a2",
                                     fontSize: '1.5rem',
                                     position: 'relative',
                                     zIndex: '9',
                                     border: '2px solid #f2f3f8',
                                     borderRadius: '100%'
                                   }}></i>
                              )}
                            </>
                          }
                          {item.step !== 4 &&
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              textWrap: "nowrap",
                              whiteSpace: "nowrap"
                            }}>
                              &nbsp;
                              {formData.status === 'relocated' && item.status === 'checked_out'
                                ? t('relocated_checked_out')
                                : t(item.status === 'confirmed' ? 'reserved' : item.status)}
                              {item.date && item.date !== null &&
                                <div style={{fontSize: '0.8rem'}}>
                                  &nbsp;
                                  {moment.utc(item.date).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                                </div>
                              }
                              {/*{item.step === 0 &&*/}
                              {/*  <div style={{fontSize: '0.8rem'}}>*/}
                              {/*    &nbsp;*/}
                              {/*    {moment.utc(formData.created_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}*/}
                              {/*  </div>*/}
                              {/*}*/}
                              {/*{item.step === 1 &&*/}
                              {/*  <div style={{fontSize: '0.8rem'}}>*/}
                              {/*    &nbsp;*/}
                              {/*    {moment.utc(formData.created_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}*/}
                              {/*  </div>*/}
                              {/*}*/}
                              {/*{item.step === 2 &&*/}
                              {/*  <div style={{fontSize: '0.8rem'}}>*/}
                              {/*    &nbsp;*/}
                              {/*    {moment.utc(formData.checked_in || formData.reserved_from).local().format(t('YYYY-MM-DD HH:mm:ss'))}*/}
                              {/*  </div>*/}
                              {/*}*/}
                              {/*{item.step === 3 &&*/}
                              {/*  <div style={{fontSize: '0.8rem'}}>*/}
                              {/*    &nbsp;*/}
                              {/*    {moment.utc(formData.checked_out || formData.reserved_to).local().format(t('YYYY-MM-DD HH:mm:ss'))}*/}
                              {/*  </div>*/}
                              {/*}*/}
                            </div>
                          }
                          {item.step === 4 && (formData.status === 'no_show' || formData.status === 'cancelled') &&
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              textWrap: "nowrap",
                              whiteSpace: "nowrap"
                            }}>
                              &nbsp;
                              {t(formData.status)}
                              {item.date && item.date !== null &&
                                <div style={{fontSize: '0.8rem'}}>
                                  &nbsp;
                                  {moment.utc(item.date).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                                </div>
                              }
                            </div>
                          }
                        </>
                      )
                    }}
          />
        </div>
      </div>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col-12 p-lg-4"}>
          <Panel className={"p-mt-0"}>
            <h3 className={"p-mt-0"}>{t('reservation_base_data')}</h3>
            {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
            <HelpComponent type={"show_box"}/>
            <HelpComponent type={"section"} tabNumber={0} sectionNumber={1}/>
            <div className={"p-grid"}>
              <div className={"p-col"}>
                <div className="p-field p-fluid">
                  <label htmlFor="unit">{t('residential_unit')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.residential_unit === null && formData.berth === null &&
                      <>
                        <span className={"p-badge danger-unit-not-found"} style={{backgroundColor: '#f7a2a2'}}>
                          {t('reservation_unit_not_found')}
                        </span>
                      </>
                    }
                    {formData.berth === null && formData.residential_unit &&
                      <>
                        {formData.residential_unit.name}
                        {/*{formData?.residential_unit?.is_ready === true ? (*/}
                        {/*  <Badge severity="success" style={{*/}
                        {/*    height: '8px',*/}
                        {/*    width: '8px',*/}
                        {/*    minWidth: '8px',*/}
                        {/*    position: 'relative',*/}
                        {/*    top: '-5px',*/}
                        {/*    left: '5px'*/}
                        {/*  }}></Badge>*/}
                        {/*) : (*/}
                        {/*  <Badge severity="danger" style={{*/}
                        {/*    height: '8px',*/}
                        {/*    width: '8px',*/}
                        {/*    minWidth: '8px',*/}
                        {/*    position: 'relative',*/}
                        {/*    top: '-5px',*/}
                        {/*    left: '5px'*/}
                        {/*  }}></Badge>*/}
                        {/*)}*/}
                      </>
                    }
                    {formData.berth?.residential_unit &&
                      <>
                        {formData.berth.residential_unit.name}
                        {/*{formData?.berth?.residential_unit?.is_ready === true ? (*/}
                        {/*  <Badge severity="success" style={{*/}
                        {/*    height: '8px',*/}
                        {/*    width: '8px',*/}
                        {/*    minWidth: '8px',*/}
                        {/*    position: 'relative',*/}
                        {/*    top: '-5px',*/}
                        {/*    left: '5px'*/}
                        {/*  }}></Badge>*/}
                        {/*) : (*/}
                        {/*  <Badge severity="danger" style={{*/}
                        {/*    height: '8px',*/}
                        {/*    width: '8px',*/}
                        {/*    minWidth: '8px',*/}
                        {/*    position: 'relative',*/}
                        {/*    top: '-5px',*/}
                        {/*    left: '5px'*/}
                        {/*  }}></Badge>*/}
                        {/*)}*/}
                      </>
                    }
                  </span>
                </div>
              </div>
              {formData.berth &&
                <div className={"p-col"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="berth">{t('berth')}</label>
                    <span className="p-d-block p-text-bold">
                        {formData.berth.name}
                  </span>
                  </div>
                </div>
              }
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="reserved_from">{t('reserved_from')}</label>
                  <span className="p-d-block p-text-bold">
                   {moment.utc(formData.reserved_from).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="reserved_to">{t('reserved_to')}</label>
                  <span className="p-d-block p-text-bold">
                   {moment.utc(formData.reserved_to).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                  </span>
                </div>
              </div>
              {/*<div className={"p-col-12 p-lg-6"}>*/}
              {/*  <div className="p-field p-fluid">*/}
              {/*    <label htmlFor="checked_in">{t('checked_in')}</label>*/}
              {/*    <span className="p-d-block p-text-bold">*/}
              {/*      {formData.checked_in === null ? (*/}
              {/*        <>{t('not_checked_in')}</>*/}
              {/*      ) : (*/}
              {/*        <>{moment.utc(formData.checked_in).local().format(t('YYYY-MM-DD HH:mm:ss'))}</>*/}
              {/*      )}*/}
              {/*    </span>*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*<div className={"p-col-12 p-lg-6"}>*/}
              {/*  <div className="p-field p-fluid">*/}
              {/*    <label htmlFor="checked_out">{t('checked_out')}</label>*/}
              {/*    <span className="p-d-block p-text-bold">*/}
              {/*      {formData.checked_out === null ? (*/}
              {/*        <>{t('not_checked_out')}</>*/}
              {/*      ) : (*/}
              {/*        <>{moment.utc(formData.checked_out).local().format(t('YYYY-MM-DD HH:mm:ss'))}</>*/}
              {/*      )}*/}
              {/*    </span>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="note">{t('note')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.note}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="guest_information_request_page">{t('guest_information_request_page')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData?.guest_information_request_page?.name}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="number_of_guests">{t('number_of_guests')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.number_of_guests}
                  </span>
                </div>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="channel">{t('channel')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.channel?.name}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="pricecategory">{t('pricecategory')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.price_category?.name}
                  </span>
                </div>
              </div>
              {reservationGroup?.group?.name &&
                <div className={"p-col-12 p-lg-6"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="reservation_group_group">{t('group')}</label>
                    <span className="p-d-flex p-ai-center p-text-bold">
                      {reservationGroup?.group?.id &&
                        <>
                          <i className={"pi pi-window-maximize"}
                             style={{cursor: 'pointer'}}
                             onClick={() => {
                               setGroupDialog(true)
                             }}></i>
                          &nbsp;
                        </>
                      }
                      {reservationGroup.group.name}
                    </span>
                  </div>
                </div>
              }
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="internal_creation">{t('internal_creation')}</label>
                  <span className="p-d-block p-text-bold">
                {formData.internal_creation === true ? (
                  <i className={"pi pi-check text-success"}></i>
                ) : (
                  <i className={"pi pi-times text-danger"}></i>
                )}
              </span>
                </div>
              </div>
            </div>
          </Panel>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {t('contact')}
            </h3>
            <HelpComponent type={"section"} tabNumber={0} sectionNumber={2}/>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="contact_name">{t('contact_name')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.contact_name}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="contact_number">{t('contact_phone')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.contact_number}
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="contact_email">{t('contact_email')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.contact_email}
                  </span>
                </div>
              </div>
            </div>
          </Panel>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0 p-mb-1"}>
              {t('hotelconnect_ntak_sync_panel_title')}
            </h3>
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <ul className="p-pl-0 p-mt-3 p-mb-0" style={{listStyle: "none"}}>
                  {renderHotelConnectSyncRow(
                    'foglalas',
                    t('hotelconnect_ntak_foglalas_sync_row_label'),
                    hotelConnectFoglalasStatusMeta,
                    isHotelConnectFoglalasSyncFailed,
                    hotelConnectFoglalasError,
                    hotelConnectRetryLoading,
                    retryHotelConnectFoglalasSync
                  )}
                  {renderHotelConnectSyncRow(
                    'checkin',
                    t('hotelconnect_ntak_checkin_sync_row_label'),
                    hotelConnectCheckinStatusMeta,
                    isHotelConnectCheckinSyncFailed,
                    hotelConnectCheckinError,
                    hotelConnectCheckinRetryLoading,
                    retryHotelConnectCheckinSync
                  )}
                  {renderHotelConnectSyncRow(
                    'checkout',
                    t('hotelconnect_ntak_checkout_sync_row_label'),
                    hotelConnectCheckoutStatusMeta,
                    isHotelConnectCheckoutSyncFailed,
                    hotelConnectCheckoutError,
                    hotelConnectCheckoutRetryLoading,
                    retryHotelConnectCheckoutSync
                  )}
                  {showHotelConnectRoomChangeSync &&
                    renderHotelConnectSyncRow(
                      'room-change',
                      t('hotelconnect_ntak_room_change_sync_row_label'),
                      hotelConnectRoomChangeStatusMeta,
                      isHotelConnectRoomChangeSyncFailed,
                      hotelConnectRoomChangeError,
                      hotelConnectRoomChangeRetryLoading,
                      retryHotelConnectRoomChangeSync
                    )
                  }
                </ul>
              </div>
            </div>
          </Panel>
        </div>
        <div className={"p-col-12 p-lg-8"}>
          {formData && formData.id &&
            <TabView activeIndex={tabActiveIndex}>
              <TabPanel header={t('guests')} className={"p-px-0"}>
                <HelpComponent type={"tab"} tabNumber={1}/>
                <Panel className={"p-mt-0"}>
                  <h3 className={"p-mt-0"}>{t('checkin_form')}</h3>
                  <HelpComponent type={"section"} tabNumber={1} sectionNumber={1}/>
                  <div className={"p-grid"}>
                    <div className={"p-col p-text-right p-col-align-center"}>
                      {formData.errors && formData.errors[0] ? (
                        <></>
                      ) : (
                        <>
                          {formData.password && formData.unique_id &&
                            <Link to={process.env.REACT_APP_APP_PROTOCOL + window.location.hostname.split('.')[0]
                              + "." + process.env.REACT_APP_APP_HOST + "public-checkin?uniqueId=" + formData.unique_id + "&password=" + formData.password}
                                  target={"_blank"} className={"p-text-secondary"}
                            >
                              <i className={"pi pi-window-maximize"}
                                 style={{position: 'relative', bottom: '-1px'}}></i> {t('check_in_link')}
                            </Link>
                          }
                        </>
                      )}
                    </div>
                  </div>
                  <p className={"p-mt-0"}>{t('send_on_edit_reservation')}</p>
                </Panel>
                <Panel className={"p-mt-3"}>
                  <h3 className={"p-mt-0"}>{t('guests')}</h3>
                  <HelpComponent type={"section"} tabNumber={1} sectionNumber={2}/>
                  <_FM_ReservationGuestListComponent reservation={formData}/>
                </Panel>
              </TabPanel>
              <TabPanel header={t('folio')} className={"p-px-0"}>
                <HelpComponent type={"tab"} tabNumber={2}/>
                <Panel className={"p-mt-0"}>
                  <h3 className={"p-mt-0"}>{t('folio')}</h3>
                  <HelpComponent type={"section"} tabNumber={2} sectionNumber={1}/>
                  <_FM_FolioListComponent reservationGroupId={formData.reservation_group.id}/>
                </Panel>
              </TabPanel>
              <TabPanel header={t('billing')} className={"p-px-0"}>
                <HelpComponent type={"tab"} tabNumber={3}/>
                <Panel className={"p-mt-0"}>
                  <HelpComponent type={"section"} tabNumber={3} sectionNumber={1}/>
                  <_FM_ReservationBillingdataFormComponent uniqueId={formData.unique_id} password={formData.password}
                                                           billingData={formData?.reservation_group?.default_billing_data}/>
                </Panel>
              </TabPanel>
              <TabPanel header={t('receipts')} className={"p-px-0"}>
                <HelpComponent type={"tab"} tabNumber={4}/>
                <Panel className={"p-mt-0"}>
                  <h3 className={"p-mt-0"}>{t('receipts')}</h3>
                  <HelpComponent type={"section"} tabNumber={4} sectionNumber={1}/>
                  <_FM_ReceiptListComponent groupId={formData.reservation_group.id}/>
                </Panel>
              </TabPanel>
              <TabPanel header={t('reservation_group')} className={"p-px-0"}>
                <HelpComponent type={"tab"} tabNumber={5}/>
                <Panel className={"p-mt-0"}>
                  <h3 className={"p-mt-0"}>{t('residential_units_in_reservation_group')}</h3>
                  <HelpComponent type={"section"} tabNumber={5} sectionNumber={1}/>
                    <_FM_ReservationgroupShowComponent reservationGroupId={formData.reservation_group.id} />
                    <p>
                      {t('attach_reservation_on_edit_reservation')}
                    </p>
                </Panel>
              </TabPanel>
              {countrySpecificEnabled !== false &&
                <TabPanel header={t('country_specific_settings')} className={"p-px-0"}>
                  <Panel className={"p-mt-0"}>
                    <ReservationCountrySpecificComponent mode="show" reservation={formData}
                                                         onEnabledChange={setCountrySpecificEnabled}/>
                  </Panel>
                </TabPanel>
              }
              {formData.price_snapshot && formData.price_snapshot.ezee ? (
                <TabPanel header={t('ezee_prices')} className={"p-px-0"}>
                  <_FM_ReservationEzeepricesListComponent prices={formData.price_snapshot.ezee} />
                </TabPanel>
              ) : (
                <></>
              )}
              {formData.resnweb_room_reference_id ? (
                <TabPanel header={'RESnWEB'} className={"p-px-0"}>
                  <_FM_ReservationResnwebListComponent reservation={formData}/>
                </TabPanel>
              ) : (
                <></>
              )}
            </TabView>
          }
        </div>
      </div>
      {formData.errors && formData.errors[0] &&
        <_FM_ReservationErrorsListComponent errors={formData.errors}/>
      }
      <Dialog header={t('group_show')}
              visible={groupDialog}
              onHide={() => {
                setGroupDialog(false)
              }}
              style={{minWidth: '960px', width: '80vw', maxWidth: '1200px'}}
              modal={false}>
        {reservationGroup?.group?.id &&
          <_FM_GroupShowComponent groupId={reservationGroup.group.id}
                                  onClose={() => {
                                    setGroupDialog(false)
                                  }}/>
        }
      </Dialog>
    </>
  )
}
export default withTranslation('common')(_FM_ReservationShowComponent);
